import React from 'react';
import './Logo.css';

const Logo = () => {
  return (
    <div className="logo-box">
      <h1 className="logo-z">
        <i className="fa-solid fa-skull" aria-label="skull logo" />
      </h1>
    </div>
  );
};

export default Logo;